var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22,
    r: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6482 24.7912L20.0268 22.6181L10.8814 31.9801H34.1825L25.2054 22.6023L22.6482 24.7912ZM26.5138 21.6087L35.2109 30.6513C35.2607 30.4758 35.2963 30.294 35.2963 30.1019V14.4719L26.5138 21.6087ZM10 14.4356V30.1019C10 30.294 10.0356 30.4758 10.0854 30.6513L18.8118 21.6379L10 14.4356ZM34.5058 13H10.7905L22.6482 22.5011L34.5058 13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ae188b57a2142ce7b9d4d26f72faa85b.svg";
export { ForwardRef as ReactComponent };